import type { CustomerNotification } from '@/entities/customer-notification/api/customer-notifications/types';
import {
    mapCustomerNotificationToNewsModalProps,
    type NewsModalContentProps,
} from '@/entities/customer-notification/lib/map-notification';
import { QueryApi } from '@/features/query/api';
import { getQueryClient } from '@/shared/api/query-client';
import { ModalService } from '@/shared/ui/modal/ModalService';
import type { ModalProps } from '@/shared/ui/modal/types';
import { markNewsRead } from './mark-news-read';

export type NewsReadPolicy = 'immediate' | 'on-close';

type OpenOptions = {
    prefab?: 'NewsDetail' | 'NewsNew' | string;
    readPolicy: NewsReadPolicy;
};

export const openCustomerNotification = async (
    notification: CustomerNotification,
    { prefab = 'NewsDetail', readPolicy }: OpenOptions,
) => {
    const queryClient = getQueryClient();
    const isLoggedIn = Boolean(queryClient.getQueryData(QueryApi.Customer.queries.Customer.queryKey));
    const props = mapCustomerNotificationToNewsModalProps(notification);

    if (readPolicy === 'immediate') {
        await markNewsRead({ id: notification.id, isLoggedIn, queryClient });
        return ModalService.showPrefab(prefab, props);
    }

    return ModalService.showPrefab(prefab, { ...props, markReadOnClose: true });
};

export const openCustomerNotificationToast = (notification: CustomerNotification) =>
    openCustomerNotification(notification, { prefab: 'NewsNew', readPolicy: 'on-close' });

export const openNewsDetailFromToast = async (
    onClose: ModalProps['onClose'],
    props: NewsModalContentProps,
) => {
    onClose('close-btn');
    const queryClient = getQueryClient();
    const isLoggedIn = Boolean(queryClient.getQueryData(QueryApi.Customer.queries.Customer.queryKey));
    if (props.notificationId) {
        await markNewsRead({ id: props.notificationId, isLoggedIn, queryClient });
    }
    return ModalService.showPrefab('NewsDetail', props);
};
